module.exports = __webpack_public_path__ + "static/media/sandwich.30e087e9.svg";